export default __webpack_public_path__ + "64bbdedfa22f447f7fc68c2e9edfcd82.csv";